import { render, staticRenderFns } from "./StartInvoice.vue?vue&type=template&id=65c688ab"
import script from "./StartInvoice.vue?vue&type=script&lang=js"
export * from "./StartInvoice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports